// extracted by mini-css-extract-plugin
export default {"check":"WalletInput_check__njIOx","address_book":"WalletInput_address_book__zpiLa"};